'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef, useState, useEffect } from 'react';
import { DrawerContainer, DrawerHandle, DrawerCard, DrawerTitle, DrawerFooter, DrawerContent, DrawerImage, DrawerOverflow, DrawerCloseButton, DrawerBackdrop, DrawerFooterBorder, DrawerStickyAction, DrawerStickyBuffer } from './elements';
import useDrawerBehavior from './useDrawerBehavior';
import { useTrapFocus, useCombinedRefs, useDisableBodyScroll, useSafeLayoutEffect, useComponentDeprecation } from '../../util';
/**
 * @deprecated
 */
export const Drawer = /*#__PURE__*/React.forwardRef(({
  open,
  title,
  imgSrc,
  footer,
  stickyAction: StickyAction,
  children,
  onOpenUpdate,
  ...rest
}, fRef) => {
  useComponentDeprecation({
    name: 'Drawer',
    version: '5'
  });
  const containerRef = useRef(null);
  const backdropRef = useRef(null);
  const contentRef = useRef(null);
  const stickyActionRef = useRef(null);
  const [stickyActionHeight, setStickyActionHeight] = useState(NaN);
  const [shrinked, setShrinked] = useState(false);
  const drawerBehavior = useDrawerBehavior(containerRef, backdropRef, contentRef, open, onOpenUpdate);
  const innerRef = React.useRef();
  const combinedRef = useCombinedRefs(fRef, innerRef);
  useTrapFocus(innerRef);
  useEffect(() => {
    const isShrinked = () => {
      if (contentRef.current) {
        const {
          offsetHeight,
          scrollHeight
        } = contentRef.current;
        setShrinked(scrollHeight > offsetHeight);
      }
    };
    window.addEventListener('resize', isShrinked);
    return () => {
      window.removeEventListener('resize', isShrinked);
    };
  }, [shrinked]);
  useSafeLayoutEffect(() => {
    if (!window.ResizeObserver) return;
    if (stickyActionRef.current) {
      setStickyActionHeight(stickyActionRef.current.offsetHeight);
      const footerObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          setStickyActionHeight(stickyActionRef.current.offsetHeight);
        });
      });
      footerObserver.observe(stickyActionRef.current);
      return () => {
        footerObserver.disconnect;
      };
    }
  }, [stickyActionRef]);
  const showContent = () => imgSrc || children;
  useDisableBodyScroll(open);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerOverflow, _extends({
    ref: combinedRef,
    isOpen: open
  }, rest, {
    "data-aui": "drawer"
  }), /*#__PURE__*/React.createElement(DrawerBackdrop, {
    ref: backdropRef,
    isOpen: open,
    onClick: drawerBehavior.onBackdropClick
  }), /*#__PURE__*/React.createElement(DrawerContainer, {
    $stickyAction: StickyAction,
    isOpen: open,
    ref: containerRef,
    role: "status",
    "aria-live": "assertive",
    "aria-hidden": !open
  }, /*#__PURE__*/React.createElement(DrawerHandle, {
    $stickyAction: StickyAction
  }), /*#__PURE__*/React.createElement(DrawerCard, {
    $stickyActionHeight: stickyActionHeight
  }, open && /*#__PURE__*/React.createElement(DrawerCloseButton, {
    "aria-label": "close drawer",
    onClick: drawerBehavior.close,
    onTouchEnd: drawerBehavior.close
  }), title && /*#__PURE__*/React.createElement(DrawerTitle, null, title), showContent() && /*#__PURE__*/React.createElement(DrawerContent, {
    ref: contentRef
  }, imgSrc && /*#__PURE__*/React.createElement(DrawerImage, {
    imgSrc: imgSrc
  }), children && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '16px'
    }
  }, children)), showContent() && footer && shrinked && /*#__PURE__*/React.createElement(DrawerFooterBorder, null), footer && /*#__PURE__*/React.createElement(DrawerFooter, footer)))), StickyAction && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerStickyBuffer, null), /*#__PURE__*/React.createElement(DrawerStickyAction, {
    ref: stickyActionRef
  }, /*#__PURE__*/React.createElement(StickyAction, null))));
});